module.exports = __webpack_public_path__ + "img/snb_kangwonland.2c3b8cb0.svg";